import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import CloseIcon from "@material-ui/icons/Close";
import NodeIcon from "./NodeIcon";

// Chip legível de um "dado do fluxo" (variável). Renderiza o ícone/cor do nó de
// origem + um rótulo amigável; o token técnico {{steps…}} fica no tooltip (com o
// valor de exemplo da última execução). O valor ARMAZENADO continua sendo o token
// — o chip é só a exibição. Ver handoff numera-var-chip.
const getByPath = (obj, path) =>
  String(path || "")
    .replace(/\[(\d+)\]/g, ".$1")
    .split(".")
    .filter(Boolean)
    .reduce((o, k) => (o == null ? undefined : o[k]), obj);

const lastSeg = p => {
  const parts = String(p || "").replace(/\[\d+\]/g, "").split(".").filter(Boolean);
  return parts[parts.length - 1] || String(p || "");
};

// token interno (sem chaves) -> { rótulo, cor, ícone do nó, valor de exemplo }
export function resolveToken(inner, groups = []) {
  const g = groups.find(gr => inner === gr.prefix || inner.startsWith(gr.prefix + "."));
  if (!g) return { label: lastSeg(inner), accent: "#5F5E5A" };
  const known = (g.known || []).find(k => k.token === inner);
  let label;
  let example;
  if (known) {
    label = lastSeg(known.key);
    example = known.example;
  } else {
    label = lastSeg(inner);
    const rel = inner === g.prefix ? "" : inner.slice(g.prefix.length + 1);
    example = rel ? getByPath(g.value, rel) : g.value;
  }
  return {
    label,
    accent: g.accent,
    verbKey: g.id === "trigger" ? null : g.verbKey,
    triggerType: g.id === "trigger" ? g.tag : null,
    category: g.category,
    example,
    title: g.title,
  };
}

const fmtEx = v => {
  if (v == null) return null;
  let s;
  if (typeof v === "object") {
    try { s = JSON.stringify(v); } catch { return null; }
  } else {
    s = String(v);
  }
  if (!s) return null;
  return s.length > 60 ? s.slice(0, 60) + "…" : s;
};

const useStyles = makeStyles(theme => {
  const a = theme.app;
  return {
    chip: {
      display: "inline-flex", alignItems: "center", gap: 6, maxWidth: "100%",
      background: "#F1F3F6", border: `1px solid ${a.border}`, borderRadius: 8,
      padding: "3px 7px 3px 5px", fontSize: 13, fontWeight: 600, color: a.ink,
      "&:hover $close": { opacity: 1 },
    },
    label: { overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" },
    close: {
      display: "inline-flex", cursor: "pointer", color: a.textTertiary, opacity: 0,
      transition: "opacity .12s", marginLeft: 1, "&:hover": { color: a.danger }, "& svg": { fontSize: 15 },
    },
    tipTok: { fontFamily: a.mono, fontSize: 11.5, wordBreak: "break-all", color: "#fff" },
    tipEx: { fontSize: 11.5, color: "#B7E39A", marginTop: 4 },
  };
});

const VarChip = ({ inner, groups, onClear }) => {
  const classes = useStyles();
  const r = resolveToken(inner, groups);
  const ex = fmtEx(r.example);
  const tip = (
    <div>
      <div className={classes.tipTok}>{`{{${inner}}}`}</div>
      {ex != null && <div className={classes.tipEx}>ex: {ex}</div>}
    </div>
  );
  return (
    <Tooltip title={tip} arrow placement="top">
      <span className={classes.chip}>
        <NodeIcon verbKey={r.verbKey} triggerType={r.triggerType} category={r.category} color={r.accent} size={17} chip />
        <span className={classes.label}>{r.label}</span>
        {onClear && (
          <span className={classes.close} onClick={e => { e.stopPropagation(); onClear(); }} title="Remover">
            <CloseIcon />
          </span>
        )}
      </span>
    </Tooltip>
  );
};

export default VarChip;
